import React from 'react';
import PropTypes from 'prop-types';
import styled, {css} from 'styled-components';
import {LimitedWidthColumns} from '../Columns';
import instructionBackground from './assets/background.svg';
import alvaLogo from './assets/logo.svg';
import LanguageToggle from '../../LanguageToggle';

const columnsCss = css`
  align-items: stretch;
  @media only screen and (max-width: 768px) {
    min-height: 100%;
  }
`;

const formColumnCss = css`
  overflow-y: auto;
  @media only screen and (max-width: 768px) {
    padding: 0 24px;
    background: white;
  }
`;

const instructionColumnCss = css`
  overflow-y: auto;
  @media only screen and (max-width: 768px) {
    padding: 0 24px;
    background: url('${instructionBackground}') center center no-repeat;
    background-size: cover;
  }
`;

export class InstructionLayout extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        instruction: PropTypes.node.isRequired,
        loading: PropTypes.bool
    };

    renderForm = () => {
        return (
            this.props.children
        );
    };

    renderDescription = () => {
        return (
            <div>
                {this.props.instruction}
                <LogoWrapper>
                    <Logo/>
                </LogoWrapper>
            </div>
        );
    };

    render() {

        return (
            <Wrapper>
                <BackgroundLayout>
                    <LeftHalfWrapper/>
                    <RightHalfWrapper/>
                </BackgroundLayout>
                <ContentWrapper>
                    {this.props.loading ? null : (
                        <LimitedWidthColumns noMargin={true} css={columnsCss} columns={[
                            {
                                size: 4,
                                render: this.renderForm,
                                offset: 0,
                                offsetRight: 1,
                                css: formColumnCss
                            },
                            {
                                size: 4,
                                render: this.renderDescription,
                                offset: 1,
                                offsetRight: 0,
                                css: instructionColumnCss
                            }
                        ]}>
                        </LimitedWidthColumns>
                    )}
                </ContentWrapper>
                <LanguageToggleWrapper>
                    <LanguageToggle fullWidth={true}/>
                </LanguageToggleWrapper>
            </Wrapper>
        );
    }
}

const Wrapper = styled.div`
  min-height: 100%;
  position: relative;
`;

const LanguageToggleWrapper = styled.div`
  top: 12px;
  left: 24px;
  position: absolute;
  width: 96px;
  
  @media only screen and (max-width: 768px) {
    top: 24px;
    left: initial;
    right: 24px;
  }
`;

const BackgroundLayout = styled.div`
  min-height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex: 1 1;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const LeftHalfWrapper = styled.div`
  flex: 0 0 50%;
  background: white;
`;

const RightHalfWrapper = styled.div`
  flex: 0 0 50%;
  background: url('${instructionBackground}') center center no-repeat;
  background-size: cover;
`;

const ContentWrapper = styled.div`
  position: relative;
`;

const LogoWrapper = styled.div`
  margin: 48px 0 24px 0;
  display: flex;
  justify-content: flex-end;
`;

const Logo = styled.div`
  background-size: cover;
  height: 22px;
  width: 95px;
  background: url('${alvaLogo}'), no-repeat center center;
`;
